import type { Ceiling } from "building-types/ceilings/ceiling";
import { CeilingType } from "building-types/ceilings/ceiling";
import type { PolyLine2 } from "geom/polyLine2Types";

export function isEditableCeilingOutline(ceiling: Ceiling | null):
  | {
      isEditable: false;
      editableOutline: null;
    }
  | {
      isEditable: true;
      editableOutline: PolyLine2;
    } {
  if (!ceiling || ceiling.type !== CeilingType.TRAY_FREEFORM || !ceiling.outline) {
    return { isEditable: false, editableOutline: null };
  }

  return { isEditable: true, editableOutline: ceiling.outline };
}
